import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function WorkBook3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6.71429 2V30H1V2H6.71429ZM9.57143 2H23.8643C25.4386 2 26.7143 3.2572 26.7143 4.786V27.214C26.7143 28.7526 25.4386 30 23.8643 30H9.57143V2ZM28.1429 7.6H31V13.2H28.1429V7.6ZM28.1429 16H31V21.6H28.1429V16ZM18.1429 16C18.9006 16 19.6273 15.705 20.1632 15.1799C20.699 14.6548 21 13.9426 21 13.2C21 12.4574 20.699 11.7452 20.1632 11.2201C19.6273 10.695 18.9006 10.4 18.1429 10.4C17.3851 10.4 16.6584 10.695 16.1226 11.2201C15.5867 11.7452 15.2857 12.4574 15.2857 13.2C15.2857 13.9426 15.5867 14.6548 16.1226 15.1799C16.6584 15.705 17.3851 16 18.1429 16ZM13.8571 21.6H22.4286C22.4286 20.4861 21.977 19.4178 21.1733 18.6302C20.3696 17.8425 19.2795 17.4 18.1429 17.4C17.0062 17.4 15.9161 17.8425 15.1124 18.6302C14.3087 19.4178 13.8571 20.4861 13.8571 21.6Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
